import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icon';

export default function ArticleInfoButton({
  shouldShow, onClick, restoreFocus, focusRestored,
}) {
  const articleInfoButton = useRef(null);

  useEffect(() => {
    if (restoreFocus && articleInfoButton.current) {
      articleInfoButton.current.focus();

      focusRestored();
    }
  }, [restoreFocus, articleInfoButton, focusRestored]);

  const onMouseLeave = useCallback(() => {
    if (articleInfoButton.current) {
      articleInfoButton.current.blur();
    }
  }, [articleInfoButton]);

  if (!shouldShow) {
    return null;
  }

  return (
    <button
      aria-label="Open article information"
      id="article-info"
      className="article-info-button"
      type="button"
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      ref={articleInfoButton}
    >
      <Icon.Info />
    </button>
  );
}

ArticleInfoButton.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  restoreFocus: PropTypes.bool.isRequired,
  focusRestored: PropTypes.func.isRequired,
};
